import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import * as debug from 'debug';
import { AuthenticationService } from '@app/core';
import { PlayerStatsService } from '@app/core/player-stats.service';
import { PlayerStats } from '@app/models/player-stats.model';
import { Subscription } from 'rxjs/Subscription';
import { ServerType } from '@app/games/models/server-type.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/takeUntil';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { PlayerService } from '@app/player.service';

@Component({
  selector: 'app-game-statistics-2',
  templateUrl: './game-statistics.template.html',
  styleUrls: ['./game-statistics.component.scss'],
  animations: [
    trigger('animate', [
      state(
        'false',
        style({
          transform: 'translateY(100%)',
          opacity: 0,
          display: 'none',
        })
      ),
      state(
        'true',
        style({
          transform: 'translateY(0%)',
          display: 'block',
          opacity: '*',
        })
      ),
      transition('false => true', animate('200ms ease-in')),
      transition('true => false', animate('200ms ease-out')),
    ]),
  ],
})
export class GameStatisticsComponent implements OnInit, OnDestroy {
  @ViewChild('elem') element: ElementRef;

  private _modeSub: Subscription;

  mouseMoveEvent;
  mouseUpEvent;
  xStartElementPoint;
  yStartElementPoint;
  xStartMousePoint;
  yStartMousePoint;

  dragging: (event: any) => void;
  mouseup: (event: any) => void;

  elWidth: number;
  elHeight: number;

  constructor(
    private auth: AuthenticationService,
    private stats: PlayerStatsService,
    private renderer: Renderer2,
    public player: PlayerService
  ) {
    this.mouseup = this.unboundMouseup.bind(this);
    this.dragging = this.unboundDragging.bind(this);
  }

  ngOnInit() {
    this._modeSub = this.player.makeChange().subscribe(e => {
      this.stats.resetStats();
    });
    this.elHeight = this.element.nativeElement.clientHeight / 2;
    this.elWidth = this.element.nativeElement.clientWidth / 2;
  }

  ngOnDestroy() {
    if (this._modeSub) {
      this._modeSub.unsubscribe();
    }
  }

  close(): void {
    this.stats.toggleStats();
  }

  public data(): PlayerStats {
    return this.stats.stats;
  }

  enabled(): boolean {
    return this.stats.isEnabled();
  }

  mousedown(event: MouseEvent) {
    if (event.button === 0) {
      this.xStartElementPoint = this.element.nativeElement.getBoundingClientRect().left + window.scrollX;
      this.yStartElementPoint = this.element.nativeElement.getBoundingClientRect().top + window.scrollX;

      this.xStartMousePoint = event.pageX;
      this.yStartMousePoint = event.pageY;

      if (this.mouseMoveEvent) {
        this.mouseMoveEvent();
      }
      if (this.mouseUpEvent) {
        this.mouseUpEvent();
      }

      this.mouseMoveEvent = this.renderer.listen('document', 'mousemove', this.dragging);
      this.mouseUpEvent = this.renderer.listen('document', 'mouseup', this.mouseup);
    }
  }

  unboundDragging(event: MouseEvent) {
    this.element.nativeElement.style.left =
      this.xStartElementPoint + (event.pageX - this.xStartMousePoint) - this.elWidth + 'px';
    this.element.nativeElement.style.top =
      this.yStartElementPoint + (event.pageY - this.yStartMousePoint) - this.elHeight + 'px';
    this.element.nativeElement.style.right = 'auto';
  }

  unboundMouseup(event: MouseEvent) {
    this.mouseMoveEvent();
    this.mouseUpEvent();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/games/shared/game-statistics/game-statistics.component.ts